// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"184":"7a2dbd7f","426":"d83ce6f5","703":"0dfd8d72"}[chunkId] + ".chunk.css";
};